import { dataHooks } from '@wix/data-hooks'

export const wixMobileCheckToggleDataHooks = dataHooks<{
  icon: {}
}>('wix-mobile-check-toggle')
